export function strictCompose(fns) {
    return fns.reduce((leftFn, rightFn) => (x) => leftFn(rightFn(x)), x => x);
}



//////////////////
// WEBPACK FOOTER
// ./src/compose.ts
// module id = 6
// module chunks = 0